import "./main.css";
import {Item as $d15e9ac28055143d$re_export$Item} from "@react-stately/collections";
import {ActionButton as $8i8bG$ActionButton} from "@react-spectrum/button";
import $8i8bG$spectrumiconsuiChevronDownMedium from "@spectrum-icons/ui/ChevronDownMedium";
import {useSlotProps as $8i8bG$useSlotProps, useDOMRef as $8i8bG$useDOMRef, useStyleProps as $8i8bG$useStyleProps, classNames as $8i8bG$classNames, ClearSlots as $8i8bG$ClearSlots, SlotProvider as $8i8bG$SlotProvider} from "@react-spectrum/utils";
import {useValueEffect as $8i8bG$useValueEffect, useResizeObserver as $8i8bG$useResizeObserver, useLayoutEffect as $8i8bG$useLayoutEffect, filterDOMProps as $8i8bG$filterDOMProps, mergeProps as $8i8bG$mergeProps, useId as $8i8bG$useId} from "@react-aria/utils";
import {FocusScope as $8i8bG$FocusScope} from "@react-aria/focus";
import {MenuTrigger as $8i8bG$MenuTrigger, Menu as $8i8bG$Menu, Item as $8i8bG$Item} from "@react-spectrum/menu";
import {useListState as $8i8bG$useListState} from "@react-stately/list";
import $8i8bG$spectrumiconsworkflowMore from "@spectrum-icons/workflow/More";
import {useHover as $8i8bG$useHover, PressResponder as $8i8bG$PressResponder} from "@react-aria/interactions";
import {useProviderProps as $8i8bG$useProviderProps, Provider as $8i8bG$Provider} from "@react-spectrum/provider";
import $8i8bG$react, {useRef as $8i8bG$useRef, useMemo as $8i8bG$useMemo, useCallback as $8i8bG$useCallback, forwardRef as $8i8bG$forwardRef, useState as $8i8bG$useState} from "react";
import {Text as $8i8bG$Text} from "@react-spectrum/text";
import {TooltipTrigger as $8i8bG$TooltipTrigger, Tooltip as $8i8bG$Tooltip} from "@react-spectrum/tooltip";
import {useActionGroup as $8i8bG$useActionGroup, useActionGroupItem as $8i8bG$useActionGroupItem} from "@react-aria/actiongroup";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $086e93d2352a4536$exports = {};

$parcel$export($086e93d2352a4536$exports, "focus-ring", () => $086e93d2352a4536$export$f39a09f249340e2a, (v) => $086e93d2352a4536$export$f39a09f249340e2a = v);
$parcel$export($086e93d2352a4536$exports, "i18nFontFamily", () => $086e93d2352a4536$export$8c4ee2c50c22c514, (v) => $086e93d2352a4536$export$8c4ee2c50c22c514 = v);
$parcel$export($086e93d2352a4536$exports, "is-active", () => $086e93d2352a4536$export$20fd0f7cd4e6112f, (v) => $086e93d2352a4536$export$20fd0f7cd4e6112f = v);
$parcel$export($086e93d2352a4536$exports, "is-disabled", () => $086e93d2352a4536$export$d35bc1e505d1ebbf, (v) => $086e93d2352a4536$export$d35bc1e505d1ebbf = v);
$parcel$export($086e93d2352a4536$exports, "is-focused", () => $086e93d2352a4536$export$e7dc768d35940237, (v) => $086e93d2352a4536$export$e7dc768d35940237 = v);
$parcel$export($086e93d2352a4536$exports, "is-hovered", () => $086e93d2352a4536$export$b8813cd5d7824ce7, (v) => $086e93d2352a4536$export$b8813cd5d7824ce7 = v);
$parcel$export($086e93d2352a4536$exports, "is-open", () => $086e93d2352a4536$export$a9781837241c946d, (v) => $086e93d2352a4536$export$a9781837241c946d = v);
$parcel$export($086e93d2352a4536$exports, "is-placeholder", () => $086e93d2352a4536$export$e5b2f5233e4e5194, (v) => $086e93d2352a4536$export$e5b2f5233e4e5194 = v);
$parcel$export($086e93d2352a4536$exports, "is-selected", () => $086e93d2352a4536$export$1e0fb04f31d3c22a, (v) => $086e93d2352a4536$export$1e0fb04f31d3c22a = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-BaseButton", () => $086e93d2352a4536$export$f7b415378ab4f839, (v) => $086e93d2352a4536$export$f7b415378ab4f839 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FocusRing-ring", () => $086e93d2352a4536$export$4109102f950813a6, (v) => $086e93d2352a4536$export$4109102f950813a6 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FocusRing", () => $086e93d2352a4536$export$24c7f46a6e3605dd, (v) => $086e93d2352a4536$export$24c7f46a6e3605dd = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton", () => $086e93d2352a4536$export$53da69f51b770d3, (v) => $086e93d2352a4536$export$53da69f51b770d3 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--emphasized", () => $086e93d2352a4536$export$5aabb61a966e266f, (v) => $086e93d2352a4536$export$5aabb61a966e266f = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--quiet", () => $086e93d2352a4536$export$40e1f009544bacf3, (v) => $086e93d2352a4536$export$40e1f009544bacf3 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--staticBlack", () => $086e93d2352a4536$export$8f7c9db66978d20f, (v) => $086e93d2352a4536$export$8f7c9db66978d20f = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--staticColor", () => $086e93d2352a4536$export$29b7b5d6a5a497c5, (v) => $086e93d2352a4536$export$29b7b5d6a5a497c5 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--staticWhite", () => $086e93d2352a4536$export$ccc536e1adbdc059, (v) => $086e93d2352a4536$export$ccc536e1adbdc059 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton-hold", () => $086e93d2352a4536$export$4a4f01c443eff992, (v) => $086e93d2352a4536$export$4a4f01c443eff992 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton-label", () => $086e93d2352a4536$export$ebb4635c66bacdb9, (v) => $086e93d2352a4536$export$ebb4635c66bacdb9 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button", () => $086e93d2352a4536$export$1db4cca5b4ade39a, (v) => $086e93d2352a4536$export$1db4cca5b4ade39a = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button--iconOnly", () => $086e93d2352a4536$export$c1d306ec0fae3838, (v) => $086e93d2352a4536$export$c1d306ec0fae3838 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button--overBackground", () => $086e93d2352a4536$export$5cda1128f9112d2e, (v) => $086e93d2352a4536$export$5cda1128f9112d2e = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button--pending", () => $086e93d2352a4536$export$54592d0984f245d5, (v) => $086e93d2352a4536$export$54592d0984f245d5 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button-circleLoader", () => $086e93d2352a4536$export$76d4531f0342bbe0, (v) => $086e93d2352a4536$export$76d4531f0342bbe0 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button-label", () => $086e93d2352a4536$export$c081ba562e204942, (v) => $086e93d2352a4536$export$c081ba562e204942 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ClearButton", () => $086e93d2352a4536$export$b752ce409e5660c, (v) => $086e93d2352a4536$export$b752ce409e5660c = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ClearButton--overBackground", () => $086e93d2352a4536$export$116f2fccf941d34d, (v) => $086e93d2352a4536$export$116f2fccf941d34d = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ClearButton--small", () => $086e93d2352a4536$export$49280ffa5236ba8b, (v) => $086e93d2352a4536$export$49280ffa5236ba8b = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FieldButton", () => $086e93d2352a4536$export$a024c99ecf6b5741, (v) => $086e93d2352a4536$export$a024c99ecf6b5741 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FieldButton--invalid", () => $086e93d2352a4536$export$c9f503f672e8a3c1, (v) => $086e93d2352a4536$export$c9f503f672e8a3c1 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FocusRing--quiet", () => $086e93d2352a4536$export$2927016961429360, (v) => $086e93d2352a4536$export$2927016961429360 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FieldButton--quiet", () => $086e93d2352a4536$export$5ca7b274e4fff9fc, (v) => $086e93d2352a4536$export$5ca7b274e4fff9fc = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Icon", () => $086e93d2352a4536$export$d374b04f30360026, (v) => $086e93d2352a4536$export$d374b04f30360026 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-LogicButton", () => $086e93d2352a4536$export$36ae67a131730482, (v) => $086e93d2352a4536$export$36ae67a131730482 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-LogicButton--and", () => $086e93d2352a4536$export$e52daab43a62c528, (v) => $086e93d2352a4536$export$e52daab43a62c528 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-LogicButton--or", () => $086e93d2352a4536$export$da76be6126aaa633, (v) => $086e93d2352a4536$export$da76be6126aaa633 = v);
var $086e93d2352a4536$export$f39a09f249340e2a;
var $086e93d2352a4536$export$8c4ee2c50c22c514;
var $086e93d2352a4536$export$20fd0f7cd4e6112f;
var $086e93d2352a4536$export$d35bc1e505d1ebbf;
var $086e93d2352a4536$export$e7dc768d35940237;
var $086e93d2352a4536$export$b8813cd5d7824ce7;
var $086e93d2352a4536$export$a9781837241c946d;
var $086e93d2352a4536$export$e5b2f5233e4e5194;
var $086e93d2352a4536$export$1e0fb04f31d3c22a;
var $086e93d2352a4536$export$f7b415378ab4f839;
var $086e93d2352a4536$export$4109102f950813a6;
var $086e93d2352a4536$export$24c7f46a6e3605dd;
var $086e93d2352a4536$export$53da69f51b770d3;
var $086e93d2352a4536$export$5aabb61a966e266f;
var $086e93d2352a4536$export$40e1f009544bacf3;
var $086e93d2352a4536$export$8f7c9db66978d20f;
var $086e93d2352a4536$export$29b7b5d6a5a497c5;
var $086e93d2352a4536$export$ccc536e1adbdc059;
var $086e93d2352a4536$export$4a4f01c443eff992;
var $086e93d2352a4536$export$ebb4635c66bacdb9;
var $086e93d2352a4536$export$1db4cca5b4ade39a;
var $086e93d2352a4536$export$c1d306ec0fae3838;
var $086e93d2352a4536$export$5cda1128f9112d2e;
var $086e93d2352a4536$export$54592d0984f245d5;
var $086e93d2352a4536$export$76d4531f0342bbe0;
var $086e93d2352a4536$export$c081ba562e204942;
var $086e93d2352a4536$export$b752ce409e5660c;
var $086e93d2352a4536$export$116f2fccf941d34d;
var $086e93d2352a4536$export$49280ffa5236ba8b;
var $086e93d2352a4536$export$a024c99ecf6b5741;
var $086e93d2352a4536$export$c9f503f672e8a3c1;
var $086e93d2352a4536$export$2927016961429360;
var $086e93d2352a4536$export$5ca7b274e4fff9fc;
var $086e93d2352a4536$export$d374b04f30360026;
var $086e93d2352a4536$export$36ae67a131730482;
var $086e93d2352a4536$export$e52daab43a62c528;
var $086e93d2352a4536$export$da76be6126aaa633;
$086e93d2352a4536$export$f39a09f249340e2a = `Dniwja_focus-ring`;
$086e93d2352a4536$export$8c4ee2c50c22c514 = `Dniwja_i18nFontFamily`;
$086e93d2352a4536$export$20fd0f7cd4e6112f = `Dniwja_is-active`;
$086e93d2352a4536$export$d35bc1e505d1ebbf = `Dniwja_is-disabled`;
$086e93d2352a4536$export$e7dc768d35940237 = `Dniwja_is-focused`;
$086e93d2352a4536$export$b8813cd5d7824ce7 = `Dniwja_is-hovered`;
$086e93d2352a4536$export$a9781837241c946d = `Dniwja_is-open`;
$086e93d2352a4536$export$e5b2f5233e4e5194 = `Dniwja_is-placeholder`;
$086e93d2352a4536$export$1e0fb04f31d3c22a = `Dniwja_is-selected`;
$086e93d2352a4536$export$f7b415378ab4f839 = `Dniwja_spectrum-BaseButton ${$086e93d2352a4536$export$8c4ee2c50c22c514}`;
$086e93d2352a4536$export$4109102f950813a6 = `Dniwja_spectrum-FocusRing-ring`;
$086e93d2352a4536$export$24c7f46a6e3605dd = `Dniwja_spectrum-FocusRing ${$086e93d2352a4536$export$4109102f950813a6}`;
$086e93d2352a4536$export$53da69f51b770d3 = `Dniwja_spectrum-ActionButton ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$5aabb61a966e266f = `Dniwja_spectrum-ActionButton--emphasized`;
$086e93d2352a4536$export$40e1f009544bacf3 = `Dniwja_spectrum-ActionButton--quiet`;
$086e93d2352a4536$export$8f7c9db66978d20f = `Dniwja_spectrum-ActionButton--staticBlack`;
$086e93d2352a4536$export$29b7b5d6a5a497c5 = `Dniwja_spectrum-ActionButton--staticColor`;
$086e93d2352a4536$export$ccc536e1adbdc059 = `Dniwja_spectrum-ActionButton--staticWhite`;
$086e93d2352a4536$export$4a4f01c443eff992 = `Dniwja_spectrum-ActionButton-hold`;
$086e93d2352a4536$export$ebb4635c66bacdb9 = `Dniwja_spectrum-ActionButton-label`;
$086e93d2352a4536$export$1db4cca5b4ade39a = `Dniwja_spectrum-Button ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$c1d306ec0fae3838 = `Dniwja_spectrum-Button--iconOnly`;
$086e93d2352a4536$export$5cda1128f9112d2e = `Dniwja_spectrum-Button--overBackground`;
$086e93d2352a4536$export$54592d0984f245d5 = `Dniwja_spectrum-Button--pending`;
$086e93d2352a4536$export$76d4531f0342bbe0 = `Dniwja_spectrum-Button-circleLoader`;
$086e93d2352a4536$export$c081ba562e204942 = `Dniwja_spectrum-Button-label`;
$086e93d2352a4536$export$b752ce409e5660c = `Dniwja_spectrum-ClearButton ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$116f2fccf941d34d = `Dniwja_spectrum-ClearButton--overBackground`;
$086e93d2352a4536$export$49280ffa5236ba8b = `Dniwja_spectrum-ClearButton--small`;
$086e93d2352a4536$export$a024c99ecf6b5741 = `Dniwja_spectrum-FieldButton ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$c9f503f672e8a3c1 = `Dniwja_spectrum-FieldButton--invalid`;
$086e93d2352a4536$export$2927016961429360 = `Dniwja_spectrum-FocusRing--quiet`;
$086e93d2352a4536$export$5ca7b274e4fff9fc = `Dniwja_spectrum-FieldButton--quiet ${$086e93d2352a4536$export$2927016961429360}`;
$086e93d2352a4536$export$d374b04f30360026 = `Dniwja_spectrum-Icon`;
$086e93d2352a4536$export$36ae67a131730482 = `Dniwja_spectrum-LogicButton ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$e52daab43a62c528 = `Dniwja_spectrum-LogicButton--and`;
$086e93d2352a4536$export$da76be6126aaa633 = `Dniwja_spectrum-LogicButton--or`;












var $331477f4233fd1ae$exports = {};

$parcel$export($331477f4233fd1ae$exports, "flex-container", () => $331477f4233fd1ae$export$69d7a39fa31a000b, (v) => $331477f4233fd1ae$export$69d7a39fa31a000b = v);
$parcel$export($331477f4233fd1ae$exports, "flex-gap", () => $331477f4233fd1ae$export$31a9da8b58047a44, (v) => $331477f4233fd1ae$export$31a9da8b58047a44 = v);
$parcel$export($331477f4233fd1ae$exports, "is-hovered", () => $331477f4233fd1ae$export$b8813cd5d7824ce7, (v) => $331477f4233fd1ae$export$b8813cd5d7824ce7 = v);
$parcel$export($331477f4233fd1ae$exports, "is-selected", () => $331477f4233fd1ae$export$1e0fb04f31d3c22a, (v) => $331477f4233fd1ae$export$1e0fb04f31d3c22a = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup", () => $331477f4233fd1ae$export$cd2a778fcee9ca5c, (v) => $331477f4233fd1ae$export$cd2a778fcee9ca5c = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup--compact", () => $331477f4233fd1ae$export$a8ccf3eb925252bd, (v) => $331477f4233fd1ae$export$a8ccf3eb925252bd = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup--justified", () => $331477f4233fd1ae$export$565332043c1dc688, (v) => $331477f4233fd1ae$export$565332043c1dc688 = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup--overflowCollapse", () => $331477f4233fd1ae$export$8e862a39302377c1, (v) => $331477f4233fd1ae$export$8e862a39302377c1 = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup--quiet", () => $331477f4233fd1ae$export$72623314301ff89b, (v) => $331477f4233fd1ae$export$72623314301ff89b = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup--vertical", () => $331477f4233fd1ae$export$b76f0727b879d41c, (v) => $331477f4233fd1ae$export$b76f0727b879d41c = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup-item", () => $331477f4233fd1ae$export$94ffe66966d2f53b, (v) => $331477f4233fd1ae$export$94ffe66966d2f53b = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup-item--iconOnly", () => $331477f4233fd1ae$export$db27a979adeba484, (v) => $331477f4233fd1ae$export$db27a979adeba484 = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup-item--isDisabled", () => $331477f4233fd1ae$export$e5274b4bc2184bc9, (v) => $331477f4233fd1ae$export$e5274b4bc2184bc9 = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup-itemIcon", () => $331477f4233fd1ae$export$dbcf6b70bcfd6e69, (v) => $331477f4233fd1ae$export$dbcf6b70bcfd6e69 = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup-menu", () => $331477f4233fd1ae$export$a56eb57dbecb1bdd, (v) => $331477f4233fd1ae$export$a56eb57dbecb1bdd = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup-menu-chevron", () => $331477f4233fd1ae$export$96da682f48d2c62a, (v) => $331477f4233fd1ae$export$96da682f48d2c62a = v);
$parcel$export($331477f4233fd1ae$exports, "spectrum-ActionGroup-menu-contents", () => $331477f4233fd1ae$export$1733ee5cd2fc5d66, (v) => $331477f4233fd1ae$export$1733ee5cd2fc5d66 = v);
var $331477f4233fd1ae$export$69d7a39fa31a000b;
var $331477f4233fd1ae$export$31a9da8b58047a44;
var $331477f4233fd1ae$export$b8813cd5d7824ce7;
var $331477f4233fd1ae$export$1e0fb04f31d3c22a;
var $331477f4233fd1ae$export$cd2a778fcee9ca5c;
var $331477f4233fd1ae$export$a8ccf3eb925252bd;
var $331477f4233fd1ae$export$565332043c1dc688;
var $331477f4233fd1ae$export$8e862a39302377c1;
var $331477f4233fd1ae$export$72623314301ff89b;
var $331477f4233fd1ae$export$b76f0727b879d41c;
var $331477f4233fd1ae$export$94ffe66966d2f53b;
var $331477f4233fd1ae$export$db27a979adeba484;
var $331477f4233fd1ae$export$e5274b4bc2184bc9;
var $331477f4233fd1ae$export$dbcf6b70bcfd6e69;
var $331477f4233fd1ae$export$a56eb57dbecb1bdd;
var $331477f4233fd1ae$export$96da682f48d2c62a;
var $331477f4233fd1ae$export$1733ee5cd2fc5d66;
$331477f4233fd1ae$export$69d7a39fa31a000b = `OizFzW_flex-container`;
$331477f4233fd1ae$export$31a9da8b58047a44 = `OizFzW_flex-gap`;
$331477f4233fd1ae$export$b8813cd5d7824ce7 = `OizFzW_is-hovered`;
$331477f4233fd1ae$export$1e0fb04f31d3c22a = `OizFzW_is-selected`;
$331477f4233fd1ae$export$cd2a778fcee9ca5c = `OizFzW_spectrum-ActionGroup`;
$331477f4233fd1ae$export$a8ccf3eb925252bd = `OizFzW_spectrum-ActionGroup--compact`;
$331477f4233fd1ae$export$565332043c1dc688 = `OizFzW_spectrum-ActionGroup--justified`;
$331477f4233fd1ae$export$8e862a39302377c1 = `OizFzW_spectrum-ActionGroup--overflowCollapse`;
$331477f4233fd1ae$export$72623314301ff89b = `OizFzW_spectrum-ActionGroup--quiet`;
$331477f4233fd1ae$export$b76f0727b879d41c = `OizFzW_spectrum-ActionGroup--vertical`;
$331477f4233fd1ae$export$94ffe66966d2f53b = `OizFzW_spectrum-ActionGroup-item`;
$331477f4233fd1ae$export$db27a979adeba484 = `OizFzW_spectrum-ActionGroup-item--iconOnly`;
$331477f4233fd1ae$export$e5274b4bc2184bc9 = `OizFzW_spectrum-ActionGroup-item--isDisabled`;
$331477f4233fd1ae$export$dbcf6b70bcfd6e69 = `OizFzW_spectrum-ActionGroup-itemIcon`;
$331477f4233fd1ae$export$a56eb57dbecb1bdd = `OizFzW_spectrum-ActionGroup-menu`;
$331477f4233fd1ae$export$96da682f48d2c62a = `OizFzW_spectrum-ActionGroup-menu-chevron`;
$331477f4233fd1ae$export$1733ee5cd2fc5d66 = `OizFzW_spectrum-ActionGroup-menu-contents`;





function $a04ee251ffcc2690$var$ActionGroup(props, ref) {
    props = (0, $8i8bG$useProviderProps)(props);
    props = (0, $8i8bG$useSlotProps)(props, "actionGroup");
    let { isEmphasized: isEmphasized, density: density, isJustified: isJustified, isDisabled: isDisabled, orientation: orientation = "horizontal", isQuiet: isQuiet, staticColor: staticColor, overflowMode: overflowMode = "wrap", onAction: onAction, buttonLabelBehavior: buttonLabelBehavior, summaryIcon: summaryIcon, ...otherProps } = props;
    let domRef = (0, $8i8bG$useDOMRef)(ref);
    let wrapperRef = (0, $8i8bG$useRef)(null);
    let state = (0, $8i8bG$useListState)({
        ...props,
        suppressTextValueWarning: true
    });
    let { actionGroupProps: actionGroupProps } = (0, $8i8bG$useActionGroup)(props, state, domRef);
    let isVertical = orientation === "vertical";
    let providerProps = {
        isEmphasized: isEmphasized,
        isDisabled: isDisabled,
        isQuiet: isQuiet
    };
    let { styleProps: styleProps } = (0, $8i8bG$useStyleProps)(props);
    // Only hide button text if every item contains more than just plain text (we assume an icon).
    let isIconCollapsible = (0, $8i8bG$useMemo)(()=>[
            ...state.collection
        ].every((item)=>typeof item.rendered !== "string"), [
        state.collection
    ]);
    let [{ visibleItems: visibleItems, hideButtonText: hideButtonText, isMeasuring: isMeasuring }, setVisibleItems] = (0, $8i8bG$useValueEffect)({
        visibleItems: state.collection.size,
        hideButtonText: buttonLabelBehavior === "hide" && isIconCollapsible,
        isMeasuring: false
    });
    let selectionMode = state.selectionManager.selectionMode;
    let updateOverflow = (0, $8i8bG$useCallback)(()=>{
        if (overflowMode === "wrap") return;
        if (orientation === "vertical" && selectionMode !== "none") // Collapsing vertical action groups with selection is currently unsupported by Spectrum.
        return;
        let computeVisibleItems = (visibleItems)=>{
            if (domRef.current && wrapperRef.current) {
                let listItems = Array.from(domRef.current.children);
                let containerSize = orientation === "horizontal" ? wrapperRef.current.getBoundingClientRect().width : wrapperRef.current.getBoundingClientRect().height;
                let isShowingMenu = visibleItems < state.collection.size;
                let calculatedSize = 0;
                let newVisibleItems = 0;
                if (isShowingMenu) {
                    let item = listItems.pop();
                    if (item) calculatedSize += orientation === "horizontal" ? $a04ee251ffcc2690$var$outerWidth(item, false, true) : $a04ee251ffcc2690$var$outerHeight(item, false, true);
                }
                for (let [i, item] of listItems.entries()){
                    calculatedSize += orientation === "horizontal" ? $a04ee251ffcc2690$var$outerWidth(item, i === 0, i === listItems.length - 1) : $a04ee251ffcc2690$var$outerHeight(item, i === 0, i === listItems.length - 1);
                    if (Math.round(calculatedSize) <= Math.round(containerSize)) newVisibleItems++;
                    else break;
                }
                // If selection is enabled, and not all of the items fit, collapse all of them into a dropdown
                // immediately rather than having some visible and some not.
                if (selectionMode !== "none" && newVisibleItems < state.collection.size) return 0;
                return newVisibleItems;
            }
            return visibleItems;
        };
        setVisibleItems(function*() {
            let hideButtonText = buttonLabelBehavior === "hide" && isIconCollapsible;
            // Update to show all items.
            yield {
                visibleItems: state.collection.size,
                hideButtonText: hideButtonText,
                isMeasuring: true
            };
            // Measure, and update to show the items that fit.
            let newVisibleItems = computeVisibleItems(state.collection.size);
            let isMeasuring = newVisibleItems < state.collection.size && newVisibleItems > 0;
            // If not all of the buttons fit, and buttonLabelBehavior is 'collapse', then first try hiding
            // the button text and only showing icons. Only if that still doesn't fit collapse into a menu.
            if (newVisibleItems < state.collection.size && buttonLabelBehavior === "collapse" && isIconCollapsible) {
                yield {
                    visibleItems: state.collection.size,
                    hideButtonText: true,
                    isMeasuring: true
                };
                newVisibleItems = computeVisibleItems(state.collection.size);
                isMeasuring = newVisibleItems < state.collection.size && newVisibleItems > 0;
                hideButtonText = true;
            }
            yield {
                visibleItems: newVisibleItems,
                hideButtonText: hideButtonText,
                isMeasuring: isMeasuring
            };
            // If the number of items is less than the number of children,
            // then update again to ensure that the menu fits.
            if (isMeasuring) yield {
                visibleItems: computeVisibleItems(newVisibleItems),
                hideButtonText: hideButtonText,
                isMeasuring: false
            };
        });
    }, [
        domRef,
        state.collection,
        setVisibleItems,
        overflowMode,
        selectionMode,
        buttonLabelBehavior,
        isIconCollapsible,
        orientation
    ]);
    // Watch the parent element for size changes. Watching only the action group itself may not work
    // in all scenarios because it may not shrink when available space is reduced.
    let parentRef = (0, $8i8bG$useMemo)(()=>({
            get current () {
                var _wrapperRef_current;
                return (_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : _wrapperRef_current.parentElement;
            }
        }), [
        wrapperRef
    ]);
    (0, $8i8bG$useResizeObserver)({
        ref: overflowMode !== "wrap" ? parentRef : undefined,
        onResize: updateOverflow
    });
    (0, $8i8bG$useLayoutEffect)(updateOverflow, [
        updateOverflow,
        state.collection
    ]);
    let children = [
        ...state.collection
    ];
    let menuItem = null;
    let menuProps = {};
    // If there are no visible items, don't apply any props to the action group container
    // and pass all aria labeling props through to the menu button.
    if (overflowMode === "collapse" && visibleItems === 0) {
        menuProps = (0, $8i8bG$filterDOMProps)(props, {
            labelable: true
        });
        actionGroupProps = {};
    }
    if (overflowMode === "collapse" && visibleItems < state.collection.size) {
        let menuChildren = children.slice(visibleItems);
        children = children.slice(0, visibleItems);
        menuItem = /*#__PURE__*/ (0, $8i8bG$react).createElement($a04ee251ffcc2690$var$ActionGroupMenu, {
            ...menuProps,
            items: menuChildren,
            onAction: onAction,
            isDisabled: isDisabled,
            isEmphasized: isEmphasized,
            staticColor: staticColor,
            state: state,
            summaryIcon: summaryIcon,
            hideButtonText: hideButtonText,
            isOnlyItem: visibleItems === 0,
            orientation: orientation
        });
    }
    let style = {
        ...styleProps.style,
        // While measuring, take up as much space as possible.
        flexBasis: isMeasuring ? "100%" : undefined
    };
    return /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$FocusScope), null, /*#__PURE__*/ (0, $8i8bG$react).createElement("div", {
        ...styleProps,
        style: style,
        className: (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($331477f4233fd1ae$exports))), "flex-container", styleProps.className),
        ref: wrapperRef
    }, /*#__PURE__*/ (0, $8i8bG$react).createElement("div", {
        ...actionGroupProps,
        ref: domRef,
        className: (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($331477f4233fd1ae$exports))), "flex-gap", "spectrum-ActionGroup", {
            "spectrum-ActionGroup--quiet": isQuiet,
            "spectrum-ActionGroup--vertical": isVertical,
            "spectrum-ActionGroup--compact": density === "compact",
            "spectrum-ActionGroup--justified": isJustified && !isMeasuring,
            "spectrum-ActionGroup--overflowCollapse": overflowMode === "collapse"
        }, otherProps.UNSAFE_className)
    }, /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$Provider), providerProps, children.map((item)=>/*#__PURE__*/ (0, $8i8bG$react).createElement($a04ee251ffcc2690$var$ActionGroupItem, {
            key: item.key,
            onAction: onAction,
            isDisabled: isDisabled,
            isEmphasized: isEmphasized,
            staticColor: staticColor,
            item: item,
            state: state,
            hideButtonText: hideButtonText,
            orientation: orientation
        })), menuItem))));
}
/**
 * An ActionGroup is a grouping of ActionButtons that are related to one another.
 */ const $a04ee251ffcc2690$export$c21a5597f732a168 = /*#__PURE__*/ (0, $8i8bG$forwardRef)($a04ee251ffcc2690$var$ActionGroup);
function $a04ee251ffcc2690$var$ActionGroupItem({ item: item, state: state, isDisabled: isDisabled, isEmphasized: isEmphasized, staticColor: staticColor, onAction: onAction, hideButtonText: hideButtonText, orientation: orientation }) {
    let ref = (0, $8i8bG$useRef)(null);
    let { buttonProps: buttonProps } = (0, $8i8bG$useActionGroupItem)({
        key: item.key
    }, state);
    isDisabled = isDisabled || state.disabledKeys.has(item.key);
    let isSelected = state.selectionManager.isSelected(item.key);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8i8bG$useHover)({
        isDisabled: isDisabled
    });
    let domProps = (0, $8i8bG$filterDOMProps)(item.props);
    if (onAction && !isDisabled) buttonProps = (0, $8i8bG$mergeProps)(buttonProps, {
        onPress: ()=>onAction(item.key)
    });
    // If button text is hidden, we need to show it as a tooltip instead, so
    // go find the text element in the DOM after rendering.
    let textId = (0, $8i8bG$useId)();
    let [textContent, setTextContent] = (0, $8i8bG$useState)("");
    (0, $8i8bG$useLayoutEffect)(()=>{
        var _document_getElementById;
        if (hideButtonText) setTextContent((_document_getElementById = document.getElementById(textId)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.textContent);
    }, [
        hideButtonText,
        item.rendered,
        textId
    ]);
    let button = // Use a PressResponder to send DOM props through.
    // ActionButton doesn't allow overriding the role by default.
    /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$PressResponder), (0, $8i8bG$mergeProps)(buttonProps, hoverProps, domProps), /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$ClearSlots), null, /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$SlotProvider), {
        slots: {
            text: {
                id: hideButtonText ? textId : null,
                isHidden: hideButtonText
            },
            icon: {
                UNSAFE_className: hideButtonText ? (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($331477f4233fd1ae$exports))), "spectrum-ActionGroup-itemIcon") : null
            }
        }
    }, /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$ActionButton), {
        ref: ref,
        UNSAFE_className: (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($331477f4233fd1ae$exports))), "spectrum-ActionGroup-item", {
            "is-selected": isSelected,
            "is-hovered": isHovered,
            "spectrum-ActionGroup-item--iconOnly": hideButtonText,
            "spectrum-ActionGroup-item--isDisabled": isDisabled
        }, (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), {
            "spectrum-ActionButton--emphasized": isEmphasized,
            "is-selected": isSelected
        })),
        isDisabled: isDisabled,
        staticColor: staticColor,
        "aria-label": item["aria-label"],
        "aria-labelledby": item["aria-label"] == null && hideButtonText ? textId : undefined
    }, item.rendered))));
    if (hideButtonText && textContent) button = /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$TooltipTrigger), {
        placement: orientation === "vertical" ? "end" : "top"
    }, button, /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$Tooltip), null, textContent));
    if (item.wrapper) button = item.wrapper(button);
    return button;
}
function $a04ee251ffcc2690$var$ActionGroupMenu({ state: state, isDisabled: isDisabled, isEmphasized: isEmphasized, staticColor: staticColor, items: items, onAction: onAction, summaryIcon: summaryIcon, hideButtonText: hideButtonText, isOnlyItem: isOnlyItem, orientation: orientation, ...otherProps }) {
    // Use the key of the first item within the menu as the key of the button.
    // The key must actually exist in the collection for focus to work correctly.
    let key = items[0].key;
    let { buttonProps: buttonProps } = (0, $8i8bG$useActionGroupItem)({
        key: key
    }, state);
    // The menu button shouldn't act like an actual action group item.
    delete buttonProps.onPress;
    delete buttonProps.role;
    delete buttonProps["aria-checked"];
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8i8bG$useHover)({
        isDisabled: isDisabled
    });
    // If no aria-label or aria-labelledby is given, provide a default one.
    let ariaLabel = otherProps["aria-label"] || (otherProps["aria-labelledby"] ? undefined : "\u2026");
    let ariaLabelledby = otherProps["aria-labelledby"];
    let textId = (0, $8i8bG$useId)();
    let id = (0, $8i8bG$useId)();
    // Summary icon only applies when selection is enabled.
    if (state.selectionManager.selectionMode === "none") summaryIcon = null;
    let iconOnly = false;
    // If there is a selection, show the selected state on the menu button.
    let isSelected = state.selectionManager.selectionMode !== "none" && !state.selectionManager.isEmpty;
    // If single selection and empty selection is not allowed, swap the contents of the button to the selected item (like a Picker).
    if (!summaryIcon && state.selectionManager.selectionMode === "single" && state.selectionManager.disallowEmptySelection && state.selectionManager.firstSelectedKey != null) {
        let selectedItem = state.collection.getItem(state.selectionManager.firstSelectedKey);
        if (selectedItem) {
            summaryIcon = selectedItem.rendered;
            if (typeof summaryIcon === "string") summaryIcon = /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$Text), null, summaryIcon);
            iconOnly = !!hideButtonText;
            ariaLabelledby = `${ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : id} ${textId}`;
        }
    }
    if (summaryIcon) // If there's a custom summary icon, also add a chevron.
    summaryIcon = /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$react).Fragment, null, /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$spectrumiconsuiChevronDownMedium), {
        UNSAFE_className: (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($331477f4233fd1ae$exports))), "spectrum-ActionGroup-menu-chevron")
    }), /*#__PURE__*/ (0, $8i8bG$react).createElement("span", {
        className: (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($331477f4233fd1ae$exports))), "spectrum-ActionGroup-menu-contents", {
            "spectrum-ActionGroup-item--iconOnly": iconOnly
        })
    }, summaryIcon));
    return(// Use a PressResponder to send DOM props through.
    /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$MenuTrigger), {
        align: isOnlyItem ? "start" : "end",
        direction: orientation === "vertical" ? "end" : "bottom"
    }, /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$SlotProvider), {
        slots: {
            text: {
                id: hideButtonText ? textId : null,
                isHidden: hideButtonText,
                UNSAFE_className: (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($331477f4233fd1ae$exports))), "spectrum-ActionGroup-menu-text")
            }
        }
    }, /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$PressResponder), (0, $8i8bG$mergeProps)(buttonProps, hoverProps), /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$ActionButton), {
        ...otherProps,
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        UNSAFE_className: (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($331477f4233fd1ae$exports))), "spectrum-ActionGroup-item", "spectrum-ActionGroup-menu", {
            "is-hovered": isHovered,
            "is-selected": isSelected
        }, (0, $8i8bG$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), {
            "is-selected": isSelected,
            "spectrum-ActionButton--emphasized": isEmphasized
        })),
        isDisabled: isDisabled,
        staticColor: staticColor
    }, summaryIcon || /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$spectrumiconsworkflowMore), null)))), /*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$Menu), {
        items: items,
        disabledKeys: state.disabledKeys,
        selectionMode: state.selectionManager.selectionMode,
        selectedKeys: state.selectionManager.selectedKeys,
        disallowEmptySelection: state.selectionManager.disallowEmptySelection,
        onSelectionChange: (keys)=>state.selectionManager.setSelectedKeys(keys),
        onAction: onAction
    }, (node)=>/*#__PURE__*/ (0, $8i8bG$react).createElement((0, $8i8bG$Item), {
            textValue: node.textValue,
            ...(0, $8i8bG$filterDOMProps)(node.props)
        }, node.rendered))));
}
function $a04ee251ffcc2690$var$outerWidth(element, ignoreLeftMargin, ignoreRightMargin) {
    let style = window.getComputedStyle(element);
    return element.getBoundingClientRect().width + (ignoreLeftMargin ? 0 : $a04ee251ffcc2690$var$toNumber(style.marginLeft)) + (ignoreRightMargin ? 0 : $a04ee251ffcc2690$var$toNumber(style.marginRight));
}
function $a04ee251ffcc2690$var$outerHeight(element, ignoreTopMargin, ignoreBottomMargin) {
    let style = window.getComputedStyle(element);
    return element.getBoundingClientRect().height + (ignoreTopMargin ? 0 : $a04ee251ffcc2690$var$toNumber(style.marginTop)) + (ignoreBottomMargin ? 0 : $a04ee251ffcc2690$var$toNumber(style.marginBottom));
}
function $a04ee251ffcc2690$var$toNumber(value) {
    let parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
}





export {$a04ee251ffcc2690$export$c21a5597f732a168 as ActionGroup, $d15e9ac28055143d$re_export$Item as Item};
//# sourceMappingURL=module.js.map
